var _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningAlertCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "red",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-circle-alert-icon lucide-circle-alert",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    x2: 12,
    y1: 8,
    y2: 12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    x2: 12.01,
    y1: 16,
    y2: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAlertCircle);
export default __webpack_public_path__ + "static/media/warning-alert-circle.2d82e1f4a7ece8c55970862c66c9dd07.svg";
export { ForwardRef as ReactComponent };